module.exports = __webpack_public_path__ + "img/svg/background-about-us-header-stains-mobile.4f4ce941696206f3cc097f4680fa853f.svg";